module.exports = __webpack_public_path__ + "static/media/Cabinet1_Before.76bbc73e.jpg";